// HoverTooltip — a lightweight tooltip that renders into a portal on document.body
// so it can never be clipped by an ancestor's `overflow: hidden` (e.g. a
// `truncate` container). Positioned with fixed coordinates from the trigger's
// bounding rect. Use where TooltipLight gets clipped.
import React, { useCallback, useRef, useState } from "react";
import ReactDOM from "react-dom";

export default function HoverTooltip({ content, children, offset = 8 }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);

  const show = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos({ top: r.bottom + offset, left: r.left + r.width / 2 });
  }, [offset]);

  const hide = useCallback(() => setPos(null), []);

  return (
    <span
      ref={ref}
      onMouseEnter={show}
      onMouseLeave={hide}
      className="inline-flex items-center"
    >
      {children}
      {pos &&
        content &&
        ReactDOM.createPortal(
          <div
            role="tooltip"
            className="pointer-events-none"
            style={{
              position: "fixed",
              top: pos.top,
              left: pos.left,
              transform: "translateX(-50%)",
              zIndex: 9999,
            }}
          >
            <div className="relative bg-[#5B5B5B] text-white text-[13px] font-medium font-outfit px-4 py-2 rounded-lg shadow-lg whitespace-nowrap">
              {/* Up-pointing arrow (caret) toward the trigger above */}
              <span
                className="absolute left-1/2 -translate-x-1/2 bottom-full w-0 h-0"
                style={{
                  borderLeft: "7px solid transparent",
                  borderRight: "7px solid transparent",
                  borderBottom: "7px solid #5B5B5B",
                }}
              />
              {content}
            </div>
          </div>,
          document.body
        )}
    </span>
  );
}
